import { ref } from 'vue'
import { defineStore } from 'pinia'
import axios from "axios";

export const useProductStore = defineStore('product', {

  state: () => ({
    product: fpe.product,
    data_sets: fpe.data_sets,
    openPanel: false,
    isUpdating: false,
    tax_enabled: fpe.tax_enabled,
    strings: fpe.strings,
    manage_stocks: fpe.manage_stocks,
    tags: [],
    panelWidth: parseInt(localStorage.getItem('fpe_panel_width')) || 400,
    variationPanelWidth: parseInt(localStorage.getItem('fpe_variation_panel_width')) || 400,
    editor_config: fpe.editor_config,
    selectedVariation: null,
    selectedVariationDetails: null,
    isLoading: false,
    isGenerating: false,
    isNewVariation: false,
    generationMessage: '',
    notice: {
      isError: false,
      isSuccess: false,
      message: '',
    },
  }),
  actions: {
    addSelectedVariation(variation) {
      this.selectedVariation = variation;
    },

    updateProduct() {
      this.isUpdating = true;
      const { ajax_url, security, product_id, edit_mode } = fpe;
      const that = this;

      axios.post(`${ajax_url}?action=fpe_product_update&fpe_nonce=${security}`, {
        product: this.product,
        product_id,
        edit_mode,
        action: 'fpe_product_update'
      })
        .then(function (response) {
          if (response.data.success) {
            if (edit_mode === 'archive') {
              window.location.reload();
            } else {
              window.location.href = response.data.product_url;
            }
            that.isUpdating = false;
          }
        })
        .catch(function (error) {
          console.log('Error updating product', error);
        })
    },
    updateVariation() {
      const { ajax_url, security } = fpe;
      const that = this;
      that.isLoading = true;
      axios.post(`${ajax_url}?action=fpe_variation_update&fpe_nonce=${security}`, {
        variation: this.selectedVariationDetails,
        product_id: this.selectedVariation,
        action: 'fpe_variation_update'
      })
        .then(function (response) {
          console.log('response', response.data.success);
          if (response.data.success == 1) {
            that.notice = {
              isError: false,
              isSuccess: true,
              message: "Variation Updated Successfully",
              _ts: Date.now(),
            };

            // Sync updated values back into the main variation list
            const variationIndex = that.product.variations.findIndex(
              v => v.id === that.selectedVariationDetails.id
            );
            if (variationIndex !== -1) {
              that.product.variations[variationIndex] = {
                ...that.product.variations[variationIndex],
                ...that.selectedVariationDetails,
              };
            }
          } else {
            that.notice = {
              isError: true,
              isSuccess: false,
              message: response.data.error || "Variation Update Failed",
              _ts: Date.now(),
            };
          }
          that.isLoading = false;
        })
        .catch(function (error) {
          that.notice = {
            isError: true,
            isSuccess: false,
            message: "Variation Update Failed",
            _ts: Date.now(),
          };
        })
    },

    togglePanel() {
      this.product = fpe.product;
      this.openPanel = !this.openPanel;
    },
    updatePanelSize(event) {
      this.panelWidth = event.width;
      localStorage.setItem('fpe_panel_width', event.width + 'px');
    },
    updateVariationPanelSize(event) {
      this.variationPanelWidth = event.width;
      localStorage.setItem('fpe_variation_panel_width', event.width + 'px');
    },
    async getTags(queryString) {
      const { ajax_url } = fpe;
      const that = this;
      await axios.post(`${ajax_url}?action=ajax-tag-search&tax=product_tag&q=${queryString}&number=20`, {

      })
        .then(function (response) {
          if (response.data.length) {
            that.tags = response.data.split('\n');
          }
        })
        .catch(function (error) {
          console.log(error);
        })
    },
    async getProducts(queryString) {
      const { ajax_url, security } = fpe;
      const that = this;
      console.log('that', that);
      await axios.post(`${ajax_url}?action=fpe_search_products&fpe_nonce=${security}&q=${queryString}&current=${this.product.id}`, {

      })
        .then(function (response) {
          that.tags = response.data;
        })
        .catch(function (error) {
          console.log(error);
        })
    },
    async getUpsellProductsByIds(ids) {

      const { ajax_url, security } = fpe;
      const that = this;
      await axios.post(`${ajax_url}?action=fpe_get_products&fpe_nonce=${security}`, {
        ids
      }).then(function (response) {
        that.product.upsell_ids = response.data;
      }).catch(function (error) {
        console.log(error);
      })
    },
    async getCrossSellProductsByIds(ids) {

      const { ajax_url, security } = fpe;
      const that = this;
      await axios.post(`${ajax_url}?action=fpe_get_products&fpe_nonce=${security}`, {
        ids
      }).then(function (response) {
        that.product.cross_sell_ids = response.data;
      }).catch(function (error) {
        console.log(error);
      })
    },
    async getGroupedProductsByIds(ids) {

      const { ajax_url, security } = fpe;
      const that = this;
      await axios.post(`${ajax_url}?action=fpe_get_products&fpe_nonce=${security}`, {
        ids
      }).then(function (response) {
        that.product.grouped_products = response.data;
      }).catch(function (error) {
        console.log(error);
      })
    },
    async getAttributeTermsById(attribute, ids) {
      const { ajax_url, security } = fpe;
      const that = this;
      await axios.post(`${ajax_url}?action=fpe_get_attribute_terms&fpe_nonce=${security}`, {
        attribute,
        ids
      }).then(function (response) {
        that.tags = response.data;
      }).catch(function (error) {
        console.log(error);
      })
    },
    setSelectedVariation(variation) {
      this.selectedVariation = variation;
    },
    async getVariationDetails(variationId) {
      const { ajax_url, security } = fpe;
      try {
        const response = await axios.post(`${ajax_url}?action=fpe_get_variation&fpe_nonce=${security}`, {
          variation: variationId,
          isAjaxCall: true
        });
        this.selectedVariationDetails = response.data.data;
        return response.data.data;
      } catch (error) {
        console.log(error);
        return null;
      }
    },
    async getVariations() {
      const { ajax_url, security } = fpe;
      try {
        const response = await axios.post(`${ajax_url}?action=fpe_get_variations&fpe_nonce=${security}`, {
          product_id: this.product.id
        });
        if (response.data.success) {
          this.product.variations = response.data.data;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async generateVariations() {
      const that = this;
      const { ajax_url, security } = fpe;
      this.isGenerating = true;
      this.generationMessage = "Generating Variations...";
      try {
        const response = await axios.post(`${ajax_url}?action=fpe_generate_variations&fpe_nonce=${security}`, {
          product_id: this.product.id,
        });
        if (response.data.success) {
          that.notice = {
            isError: false,
            isSuccess: true,
            message: `${response.data.data.generated} Variations Generated Successfully`,
            _ts: Date.now(),
          };
          this.generationMessage = "Fetching Variations...";
          await this.getVariations();
          this.isGenerating = false;
        } else {
          that.notice = {
            isError: true,
            isSuccess: false,
            message: `Failed to generate variations try again`,
            _ts: Date.now(),
          };
          this.isGenerating = false;
        }

      } catch (error) {
        console.log(error);
        this.isGenerating = false;
      }
    },
    async deleteVariation(variationId) {
      const { ajax_url, security } = fpe;
      try {
        const response = await axios.post(`${ajax_url}?action=fpe_delete_variation&fpe_nonce=${security}`, {
          variation: variationId,
          isAjaxCall: true
        });
        if (response.data.success) {
          this.notice = {
            isError: false,
            isSuccess : true,
            message : 'Variation deleted successfully',
            _ts: Date.now(),
          }
          this.getVariations();
        }else{
          this.notice = {
            isError: true,
            isSuccess : false,
            message : 'Failed to delete variation try again',
            _ts: Date.now(),
          }
        }
      } catch (error) {
        console.log(error);
      }
    },

    openNewVariation() {
      // Build empty variation object matching the shape that all sub-components expect
      const emptyAttributes = {};
      // Pre-populate attribute keys from product attributes that are used for variations
      if (this.product.attributes) {
        this.product.attributes.forEach(attr => {
          if (attr.variation) {
            const key = attr.name.toLowerCase().replace(/\s+/g, '-');
            emptyAttributes[key] = '';
          }
        });
      }

      this.selectedVariationDetails = {
        id: null,
        type: 'variation',
        name: '',
        sku: '',
        description: '',
        short_description: '',
        featured: false,
        catalog_visibility: 'visible',
        regular_price: '',
        sale_price: '',
        date_on_sale_from: '',
        date_on_sale_to: '',
        weight: '',
        length: '',
        width: '',
        height: '',
        shipping_class_id: '',
        sold_individually: false,
        manage_stocks: false,
        backorders: 'no',
        stock_quantity: 0,
        low_stock_amount: '',
        stock_status: 'instock',
        virtual: false,
        downloadable: false,
        downloads: [],
        download_limit: -1,
        download_expiry: -1,
        image: '',
        image_src: '',
        enabled: true,
        global_unique_id: '',
        attributes: emptyAttributes,
      };

      this.isNewVariation = true;
      this.selectedVariation = 'new'; // sentinel value to trigger drawer watcher
    },

    async createVariation() {
      const { ajax_url, security } = fpe;
      const that = this;
      that.isLoading = true;

      try {
        const response = await axios.post(
          `${ajax_url}?action=fpe_create_variation&fpe_nonce=${security}`,
          {
            variation: this.selectedVariationDetails,
            product_id: this.product.id,
          }
        );
        if (response.data.success) {
          that.notice = {
            isError: false,
            isSuccess: true,
            message: 'Variation Created Successfully',
            _ts: Date.now(),
          };
          // Refresh variation list
          await that.getVariations();
          // Reset new variation mode
          that.isNewVariation = false;
          that.selectedVariation = null;
          that.selectedVariationDetails = null;
        } else {
          that.notice = {
            isError: true,
            isSuccess: false,
            message: response.data.data?.message || 'Variation Creation Failed',
            _ts: Date.now(),
          };
        }
      } catch (error) {
        that.notice = {
          isError: true,
          isSuccess: false,
          message: 'Variation Creation Failed',
          _ts: Date.now(),
        };
        console.log(error);
      } finally {
        that.isLoading = false;
      }
    },

    async bulkUpdateVariationPrice(price) {
      const { ajax_url, security } = fpe;
      this.isLoading = true;

      try {
        const response = await axios.post(
          `${ajax_url}?action=fpe_bulk_update_variation_price&fpe_nonce=${security}`,
          {
            product_id: this.product.id,
            price,
          }
        );

        if (response.data.success) {
          this.notice = {
            isError: false,
            isSuccess: true,
            message: response.data.data.message || 'Prices updated successfully',
            _ts: Date.now(),
          };
          // Refresh variation list to reflect new prices
          await this.getVariations();
        } else {
          this.notice = {
            isError: true,
            isSuccess: false,
            message: response.data.data?.message || 'Bulk price update failed',
            _ts: Date.now(),
          };
        }
      } catch (error) {
        this.notice = {
          isError: true,
          isSuccess: false,
          message: 'Bulk price update failed',
          _ts: Date.now(),
        };
        console.log(error);
      } finally {
        this.isLoading = false;
      }
    },

  },
});
